import type { VoidFunctionComponent } from 'react';

import { getCookie } from '../../../../helpers/cookies';
import {
  CONTRIBUTOR_LIMIT_BANNER_DISMISSED_COOKIE_NAME,
} from '../../../projects/dashboardV2/ContributorCountLimitWarningBanner';
import { useContributorLimit } from '../../../projects/dashboardV2/hooks/useContributorLimit';
import { useReleaseGroupLimit } from '../../../projects/dashboardV2/hooks/useReleaseGroupLimit';
import {
  RELEASE_GROUP_BANNER_DISMISSED_COOKIE_NAME,
} from '../../../projects/dashboardV2/ReleaseGroupLimitWarningBanner';

import { SubscriptionBannerContainer } from './index';

export const SubscriptionBannerProjectsPageContainer:VoidFunctionComponent = () => {
  const hasDismissedReleaseGroupWarning = getCookie(RELEASE_GROUP_BANNER_DISMISSED_COOKIE_NAME) === 'true';
  const hasDismissedContributorWarning = getCookie(CONTRIBUTOR_LIMIT_BANNER_DISMISSED_COOKIE_NAME) === 'true';
  const {
    isAtReleaseGroupLimit,
    isReleaseGroupsUnlimited,
    isOverReleaseGroupLimit,
  } = useReleaseGroupLimit();

  const {
    isOverContributorLimit,
    isContributorsUnlimited,
  } = useContributorLimit();

  const isDisplayingContributorBanner =
    !isContributorsUnlimited && isOverContributorLimit && !hasDismissedContributorWarning;

  const isDisplayingReleaseGroupBanner =
    !isReleaseGroupsUnlimited && (isAtReleaseGroupLimit || isOverReleaseGroupLimit) && !hasDismissedReleaseGroupWarning;

  // Don't render the Subscription banner if any other dashboard banners are present
  if (isDisplayingContributorBanner || isDisplayingReleaseGroupBanner) {
    return null;
  }

  return (<SubscriptionBannerContainer />);
};
